export const ContextDictionary = Object.freeze({
	deal: 'deal',
	smartInvoice: 'smart_invoice',
	chat: 'chat',
	sms: 'sms',
	imOpenlines: 'imopenlines_app',
	terminalList: 'terminal_list',
});
